import { Suspense, lazy } from 'react';
import { Hero } from '../components/home/Hero';
import { SuspenseFallback } from '../components/ui/SuspenseFallback';

// Lazy loading des composants lourds
const AllInOneSection = lazy(() => import('../components/home/AllInOneSection').then(module => ({
  default: module.AllInOneSection
})));

const RDCitiesMap = lazy(() => import('../components/home/RDCitiesMap').then(module => ({
  default: module.RDCitiesMap
})));

const MobileAppSection = lazy(() => import('../components/home/MobileAppSection').then(module => ({
  default: module.MobileAppSection
})));

const Testimonials = lazy(() => import('../components/home/Testimonials').then(module => ({
  default: module.Testimonials
})));

export function Home() {
  return (
    <div className="bg-white space-y-0">
      {/* Hero toujours chargé immédiatement */}
      <Hero />
      
      {/* Sections avec lazy loading et fallbacks optimisés */}
      <Suspense fallback={<SuspenseFallback type="cards" />}>
        <AllInOneSection />
      </Suspense>
      
      <Suspense fallback={<SuspenseFallback type="chart" />}>
        <RDCitiesMap />
      </Suspense>
      
      <Suspense fallback={<SuspenseFallback type="list" />}>
        <MobileAppSection />
      </Suspense>
      
      <Suspense fallback={<SuspenseFallback type="cards" />}>
        <Testimonials />
      </Suspense>
    </div>
  );
}